module.exports = __webpack_public_path__ + "img/elec_bottom1_us.d6274f39.png";